export const ToAlphaNumeric = (str: string) => {
  return str.replace(/[^a-z0-9 -]/gi, "");
};
